<template>
  <div class="mb-6">

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Cliente"
          v-model="filters.client"
          :options="clients"
          :loading="waitClients"
          :disabled="waitClients"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          @select="filterClient"
          @remove="filterClient(false)"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Indirizzo" v-model="filters.address" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Note" v-model="filters.notes" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons is-flex">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
          <router-link to="/luoghi/new" class="button is-primary is-hidden-touch" @click="resetFilters()"><font-awesome-icon icon="plus" />Aggiungi</router-link>
        </div>
      </div>
    </div>

    <div class="b-table has-pagination" :class="{'is-loading': loading}">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
          <tr>
            <th>Cliente</th>
            <th style="width: 40px;"></th>
            <th>Indirizzo</th>
            <th>Impianti</th>
            <th>Note</th>
            <th style="min-width: 100px;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(place, index) in places" :key="index">
            <td data-label="Cliente">
              <div>
                <router-link v-if="place.client" :to="'/clienti/' + place.client._id">
                  <ClientHeading :client="place.client" />
                </router-link>
              </div>
            </td>
            <td>
              <font-awesome-icon :class="{'has-text-grey-lighter': !place.position}" icon="location-dot" />
            </td>
            <td data-label="Indirizzo">
              <AddressDisplay :value="place" />
            </td>
            <td data-label="Impianti">
              <div class="tags">
                <span class="tag is-info" v-for="(implant, index) in place.implants" :key="index">
                  <router-link class="has-text-white" :to="'/impianti/' + implant._id" v-html="$implantName(implant) || '<i>Nessun nome</i>'"></router-link>
                </span>
              </div>
            </td>
            <td data-label="Note">
              <InfoButton :text="place.notes" />
            </td>
            <td class="is-actions-cell is-justify-content-flex-end">
              <div class="buttons is-right">
                <router-link :to="'/luoghi/' + place._id" class="button is-warning" type="button" title="Modifica" :disabled="place.waitDelete">
                  <span class="icon"><font-awesome-icon icon="pen" /></span>
                </router-link>
                <button class="button is-danger" type="button" @click="deletePlace(place)" title="Elimina" :class="[{'is-loading': place.waitDelete}]" :disabled="place.waitDelete">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="places.length === 0">
            <td colspan="100" class="has-text-centered has-text-grey">
              <i>Nessun risultato</i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @change="getPlaces($event)" />
    </div>

    <router-link to="/luoghi/new" class="button is-floating is-primary is-hidden-desktop" title="Nuovo">
      <span class="icon">
        <font-awesome-icon icon="plus" />
      </span>
    </router-link>

  </div>
</template>

<script>
import AddressDisplay from '../components/AddressDisplay.vue'

export default {
  components: {
    AddressDisplay
  },

  data() {
    return {
      filters: this.$store.state.filters.place,

      clients: [],

      places: [],

      pagination:{
        total: false,
        selected: false
      },

      loading: true,
      waitClients: true
    }
  },

  methods: {
    resetFilters() {
      this.filters = {}

      this.getPlaces()
    },

    filterClient(selected) {
      this.filters.client = selected
      this.getPlaces()
    },

    getPlaces(args = {page: 1, size: 30, scroll: 0}) {
      const self = this

      this.loading = true

      this.$store.commit('setFilter', {name: 'place', value: this.filters})
      this.$store.commit('setPage', {name: 'place', value: {number: args.page, size: args.size}})

      const clientId = this.filters.client ? this.filters.client._id : null

      this.$http.get('/place', { params: {
        page: args.page,
        size: args.size,
        address: this.filters.address,
        notes: this.filters.notes,
        client: clientId
      } }).then(response => {
        if (response && response.data) {
          this.places = response.data.records
          this.pagination = {
            total: response.data.totalRecords,
            pages: response.data.totalPages,
            selected: response.data.currentPage
          }

          if (args.scroll) {
            self.$nextTick(() => {
              window.scroll(0, args.scroll)
            })
          }
        }

        this.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },

    deletePlace(place) {
      if (confirm('Eliminare?')) {
        const self = this
        place.waitDelete = true

        this.$http.delete('/place/' + place._id)
        .then(function (response) {
          self.getPlaces({page: self.$store.state.pages.place.number, size: self.$store.state.pages.place.size})
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          place.waitDelete = false
        })
      }
    }
  },

  mounted() {
    const self = this

    this.$http.get('/client/filter')
    .then(function (response) {
      self.clients = response.data

      self.waitClients = false
    })
    .catch(function (error) {
      console.log(error)
      alert('Errore')
    })

    this.getPlaces({page: this.$store.state.pages.place.number, size: this.$store.state.pages.place.size, scroll: this.$store.state.pages.place.scroll})
  },

  created() {
    this.onFilterInput = this.$debounce(() => this.getPlaces(), 500)
  },

  beforeUnmount() {
    const scroll = window.top.scrollY
    let page = Object.assign({}, this.$store.state.pages.place)
    page.scroll = scroll
    this.$store.commit('setPage', {name: 'place', value: page})
  }
}
</script>